var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrowdapps(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.417,
    height: 25,
    viewBox: "0 0 56.417 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "crowdapps_logo_combo_white",
    transform: "translate(0.014)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11718",
    "data-name": "Group 11718",
    transform: "translate(-0.014 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10117",
    "data-name": "Path 10117",
    d: "M5.042,44.693,4.537,45.7a1.8,1.8,0,0,0-1.317-.4,1.7,1.7,0,0,0-1.41.719,2.929,2.929,0,0,0-.549,1.818,2.772,2.772,0,0,0,.509,1.749,1.648,1.648,0,0,0,1.362.651,1.822,1.822,0,0,0,1.519-.695l.594.986a2.873,2.873,0,0,1-2.194.808A2.76,2.76,0,0,1,.8,50.373a3.9,3.9,0,0,1-.808-2.59A3.741,3.741,0,0,1,.877,45.23,2.869,2.869,0,0,1,3.143,44.2a3.293,3.293,0,0,1,1.895.485",
    transform: "translate(0.014 -26.341)",
    fill: "#2c3c46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10118",
    "data-name": "Path 10118",
    d: "M19.279,51.329,17.444,48.5l-.776-.028v2.873H15.4V44.477c.065,0,.331,0,.808-.04s.832-.036,1.115-.036q2.622,0,2.622,2.02a1.867,1.867,0,0,1-.364,1.111,1.939,1.939,0,0,1-.905.711l2.02,3.1Zm-2.614-5.822v1.915c.226,0,.4.024.517.024a2.251,2.251,0,0,0,1.119-.214.905.905,0,0,0,.356-.84.735.735,0,0,0-.38-.711,2.667,2.667,0,0,0-1.212-.206,3.54,3.54,0,0,0-.4.032",
    transform: "translate(-9.172 -26.461)",
    fill: "#2c3c46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10119",
    "data-name": "Path 10119",
    d: "M29.128,47.715a3.919,3.919,0,0,1,.808-2.489,2.614,2.614,0,0,1,2.158-1.014,2.828,2.828,0,0,1,2.267.921,3.859,3.859,0,0,1,.776,2.582,3.96,3.96,0,0,1-.808,2.638A2.861,2.861,0,0,1,32,51.331a2.529,2.529,0,0,1-2.129-.966,4.242,4.242,0,0,1-.735-2.65m1.265,0a3.6,3.6,0,0,0,.4,1.871,1.313,1.313,0,0,0,1.188.667,1.616,1.616,0,0,0,1.394-.65,3.143,3.143,0,0,0,.485-1.883c0-1.616-.6-2.424-1.786-2.424a1.418,1.418,0,0,0-1.253.655,3.1,3.1,0,0,0-.44,1.762",
    transform: "translate(-17.353 -26.346)",
    fill: "#2c3c46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10120",
    "data-name": "Path 10120",
    d: "M51.23,51.494h-.5l-1.507-4.339-1.459,4.339h-.505L45,44.52h1.273l1.293,4.149,1.4-4.149H49.5l1.4,4.149,1.289-4.149h1.277Z",
    transform: "translate(-26.813 -26.532)",
    fill: "#2c3c46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10121",
    "data-name": "Path 10121",
    d: "M69.263,51.335H67.74V44.466c.97-.036,1.584-.053,1.834-.053a3.232,3.232,0,0,1,2.384.877,3.16,3.16,0,0,1,.877,2.339q0,3.709-3.568,3.713m-.307-5.81V50.22a5.55,5.55,0,0,0,.634.024,1.737,1.737,0,0,0,1.45-.671,3.018,3.018,0,0,0,.521-1.879c0-1.475-.687-2.206-2.057-2.206a2.834,2.834,0,0,0-.554.036",
    transform: "translate(-40.365 -26.466)",
    fill: "#2c3c46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10122",
    "data-name": "Path 10122",
    d: "M90.391,51.273l-.517-1.382H87.53l-.461,1.382H85.72l2.727-6.933h.537l2.751,6.933Zm-1.677-4.848-.808,2.525H89.55Z",
    transform: "translate(-51.08 -26.425)",
    fill: "#2c3c46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10123",
    "data-name": "Path 10123",
    d: "M103.6,48.828v2.517H102.39V44.508c.808-.032,1.285-.048,1.418-.048a4.393,4.393,0,0,1,2.372.5,1.737,1.737,0,0,1,.752,1.552c0,1.568-.925,2.356-2.776,2.351A5.431,5.431,0,0,1,103.6,48.828Zm0-3.269v2.19c.162,0,.327.028.489.032A2.081,2.081,0,0,0,105.3,47.5a1.042,1.042,0,0,0,.4-.905q0-1.059-1.713-1.063a2.872,2.872,0,0,0-.372.024Z",
    transform: "translate(-61.015 -26.497)",
    fill: "#2c3c46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10124",
    "data-name": "Path 10124",
    d: "M117.5,48.828v2.517H116.29V44.508c.808-.032,1.285-.048,1.422-.048a4.377,4.377,0,0,1,2.368.5,1.729,1.729,0,0,1,.752,1.551c0,1.568-.925,2.356-2.772,2.351A5.311,5.311,0,0,1,117.5,48.828Zm0-3.269v2.19c.162,0,.323.028.485.032A2.081,2.081,0,0,0,119.2,47.5a1.034,1.034,0,0,0,.4-.905q0-1.059-1.713-1.063a2.828,2.828,0,0,0-.368.024Z",
    transform: "translate(-69.299 -26.497)",
    fill: "#2c3c46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10125",
    "data-name": "Path 10125",
    d: "M129.37,50.855l.448-1.087a2.453,2.453,0,0,0,1.414.5c.711,0,1.071-.246,1.071-.747a1.079,1.079,0,0,0-.255-.663,3.305,3.305,0,0,0-1.038-.715,5,5,0,0,1-1.063-.646,1.758,1.758,0,0,1-.4-.606,1.959,1.959,0,0,1-.145-.776,1.7,1.7,0,0,1,.582-1.317,2.166,2.166,0,0,1,1.495-.521,2.792,2.792,0,0,1,1.741.444l-.388,1.055a2.287,2.287,0,0,0-1.349-.461.9.9,0,0,0-.651.222.764.764,0,0,0-.23.574q0,.586,1.305,1.212a4.384,4.384,0,0,1,.986.618,1.879,1.879,0,0,1,.465.663,2.109,2.109,0,0,1,.158.836,1.705,1.705,0,0,1-.655,1.37,2.719,2.719,0,0,1-1.762.537A3.139,3.139,0,0,1,129.37,50.855Z",
    transform: "translate(-77.094 -26.383)",
    fill: "#2c3c46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10126",
    "data-name": "Path 10126",
    d: "M55.687,0A9.572,9.572,0,0,0,48.01,15.293h1.531a8.4,8.4,0,1,1,12.291,0h1.531A9.576,9.576,0,0,0,55.687,0Z",
    transform: "translate(-27.476 0)",
    fill: "#2c3c46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10127",
    "data-name": "Path 10127",
    d: "M66.665,14.335a2,2,0,0,0-1.539.638,2.343,2.343,0,0,0-.59,1.648A2.457,2.457,0,0,0,65.1,18.3a1.77,1.77,0,0,0,.739.493l-.505,3.079h2.679L67.5,18.783a1.867,1.867,0,0,0,.731-.489,2.424,2.424,0,0,0,.57-1.673,2.392,2.392,0,0,0-.562-1.677,2.02,2.02,0,0,0-1.572-.61Z",
    transform: "translate(-38.454 -8.541)",
    fill: "#2c3c46"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrowdapps);
export default __webpack_public_path__ + "static/media/crowdapps.c5eb0788ed69d2a618553ad15d00b45a.svg";
export { ForwardRef as ReactComponent };